import { c as _c } from "react/compiler-runtime";
import type { PullRequest } from '@/app/pr/[owner]/[repo]/pull/[number]/components/types';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
type ReviewerAvatarsProps = {
  reviewers: PullRequest['reviewers'];
};
export function ReviewerAvatars(t0) {
  const $ = _c(4);
  const {
    reviewers
  } = t0;
  if (!reviewers || reviewers.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== reviewers) {
    t1 = Array.from(reviewers.reduce(_temp, new Map()).values());
    $[0] = reviewers;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const uniqueReviewers = t1;
  let t2;
  if ($[2] !== uniqueReviewers) {
    t2 = <TooltipProvider><div className="-mr-1 flex -space-x-2">{uniqueReviewers.map(_temp2)}</div></TooltipProvider>;
    $[2] = uniqueReviewers;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp2(reviewer_0) {
  return <Tooltip key={reviewer_0.login}><TooltipTrigger asChild={true}><Avatar className="size-5 border-2 border-black"><AvatarImage src={reviewer_0.avatarUrl} /><AvatarFallback>{reviewer_0.login}</AvatarFallback></Avatar></TooltipTrigger><TooltipContent>{reviewer_0.login}</TooltipContent></Tooltip>;
}
function _temp(acc, reviewer) {
  const existing = acc.get(reviewer.login);
  if (!existing || reviewer.submitted_at && (!existing.submitted_at || reviewer.submitted_at > existing.submitted_at)) {
    acc.set(reviewer.login, reviewer);
  }
  return acc;
}